import {UrlSerializer, UrlTree, DefaultUrlSerializer} from '@angular/router';

export class CustomUrlSerializer implements UrlSerializer {
    parse(url: any): UrlTree {
        let urlSerializer = new DefaultUrlSerializer();
        if (/\/\//.test(url)) {
            url = url.replace(/\/\//, '/');
        }
        if (url.includes('v3/v2')) {
            url = url.replace('v3/v2', 'v3');
        }
        return urlSerializer.parse(url);
    }

    serialize(tree: UrlTree): any {
        return new DefaultUrlSerializer().serialize(tree);
    }
}
